import React, { Context, Dispatch, ReactNode, createContext, useReducer } from 'react';

interface StoreInterface<S, A> {
    state: S;
    dispatch?: Dispatch<A>;
}

export function createStore<S, A>(reducer:(state:S, action: A) => S, defaultValue:S){
    const Store = createContext<StoreInterface<S,A>>({state:defaultValue});

    function StoreProvider({ children, initialValue }:{children:ReactNode, initialValue?: S}){
        const [state, dispatch] = useReducer(reducer, initialValue || defaultValue);
    
        return <Store.Provider value={{ state, dispatch }}>
            {children}
        </Store.Provider>
    };


    return {Store, StoreProvider}
}

export function createContextProvider<S, A>(reducer:(state:S, action: A) => S, defaultValue:S):[Context<StoreInterface<S, A>>, ({ children, initialValue}:{children:ReactNode, initialValue?: S}) => JSX.Element]{
    const {Store, StoreProvider} = createStore(reducer, defaultValue);
    return [Store, StoreProvider]
}